var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-receipt-frame',{ref:"printkgireceipt",attrs:{"is-preview":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }